import { Sector, SectorValues } from '@/domain/impact/impact.entity';
import {
  CargoType,
  CargoValues,
  ImpactCo2Answer,
  Source,
  SourceValues,
  ValuesCargo,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { QuestionCargoDto } from './dto.type';

export class QuestionCargoMapper {
  static dtoToEntity(dto: QuestionCargoDto): ImpactCo2Answer<ValuesCargo> {
    return {
      id: dto.id,
      userId: dto.userId,
      sector: validateValueInType<Sector>(dto.sector, SectorValues),
      category: 'CARGO',
      isExternal: dto.isExternal,
      source: validateValueInType<Source>(dto.source || '', SourceValues),
      values: {
        transportationMode: validateValueInType<CargoType>(
          dto.transportationMode,
          CargoValues,
        ),
        weight: Number.parseFloat(dto.weight.toString()),
        travelDistance: Number.parseFloat(dto.travelDistance.toString()),
        label: dto.label || '',
        score: dto.score || 0,
        tags:
          dto?.tags?.values?.map((tag) => ({ id: tag.id, name: tag.name })) ||
          [],
      },
    };
  }

  static entityToDto(
    answer: ImpactCo2Answer<ValuesCargo>,
    projectId: number,
  ): Omit<QuestionCargoDto, 'id' | 'userId' | 'score' | 'isExternal'> {
    return {
      projectId: projectId,
      sector: answer.sector,
      transportationMode: answer.values.transportationMode,
      weight: answer.values.weight,
      travelDistance: answer.values.travelDistance,
      label: answer.values.label || '',
      source: answer.source !== '' ? answer.source : undefined,
      tags: { values: answer.values.tags },
    };
  }
}
